<template>
  <div class="filtro">
    <b-card header="Opciones de Filtro" class="card-filter">
      <b-btn class="filter-collapse" 
          variant="primary" 
          size="sm"
          @click.prevent="showOpcionesFiltro= !showOpcionesFiltro">
        <i :class="showOpcionesFiltro ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
      </b-btn>
      <b-collapse id="filtro" class="mt-2" v-model="showOpcionesFiltro">
        <b-form>
          <b-form-group>
            <b-form-radio 
              v-model="filtro.filtroNoCancelados" 
              name="filtroNoCancelados" 
              :value="true"
              stacked>Planes No Cancelados</b-form-radio>
              
              <small class="text-muted">Incluye todos los planes no cancelados</small>

              <b-collapse 
                id="filtroOpcionNoCancelados" 
                class="mt-2" 
                v-model="showOpcionesNoCancelados">

                <b-form-group
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-checkbox 
                      id="incluirPlanesCancelados"
                      v-model="filtro.incluirPlanesCancelados"
                      :value="Boolean(true)"
                      :unchecked-value= "Boolean(false)">
                      Incluir Planes Cancelados
                  </b-form-checkbox>
                </b-form-group>                

                <b-form-group
                  label="Desde"
                  label-for="fechaDesdeCancelados"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaDesdeCancelados" 
                    v-model="filtro.fechaDesdeCancelados"
                    :disabled="!filtro.incluirPlanesCancelados" 
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Hasta"
                  label-for="fechaHastaCancelados"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaHastaCancelados" 
                    v-model="filtro.fechaHastaCancelados" 
                    :disabled="!filtro.incluirPlanesCancelados" 
                    type="date">
                  </b-form-input>
                </b-form-group>
              </b-collapse>

            <b-form-radio 
              v-model="filtro.filtroNoCancelados" 
              name="filtroTodos" 
              :value="false"
              stacked>Todos los Planes</b-form-radio>

              <b-collapse 
                id="filtroOpcionTodos" 
                class="mt-2" 
                v-model="showOpcionesTodos">              

                <b-form-group
                  label="Desde"
                  label-for="fechaDesdeTodos"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaDesdeTodos" 
                    v-model="filtro.fechaDesdeTodos"
                    type="date">
                  </b-form-input>
                </b-form-group>

                <b-form-group
                  label="Hasta"
                  label-for="fechaHastaTodos"
                  :label-cols="labelCols"
                  horizontal>
                  <b-form-input 
                    id="fechaHastaTodos" 
                    v-model="filtro.fechaHastaTodos" 
                    type="date">
                  </b-form-input>
                </b-form-group>
              </b-collapse>
          </b-form-group>
        </b-form>

        <div class="footer">
          <b-button size="sm" variant="primary" class="footer-button"
            @click.prevent="filtrar">Filtrar</b-button>
          <b-button size="sm" variant="primary" class="footer-button" 
            @click.prevent="limpiarFiltro">Limpiar</b-button>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  components: {
  },
  props: {
    filtroNoCancelados: {
      type: Boolean,
      default: true,
    },
    incluirPlanesCancelados: {
      type: Boolean,
      default: false,
    },
    fechaDesdeCancelados: {
      type: String,
      default: ''
    },
    fechaHastaCancelados: {
      type: String,
      default: ''
    },
    fechaDesdeTodos: {
      type: String,
      default: ''
    },
    fechaHastaTodos: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      filtro: {
        filtroNoCancelados: true,
        filtroTodos: false,

        incluirPlanesCancelados: false,
        fechaDesdeCancelados: '',
        fechaHastaCancelados: '',
        fechaDesdeTodos: '',
        fechaHastaTodos: '',
      },
      showOpcionesFiltro: Boolean(false),
      labelCols: 2,
      showOpcionesNoCancelados: true,
      showOpcionesTodos: false,
    }
  },
  created() {
    this.filtro.filtroNoCancelados = this.filtroNoCancelados;
    this.filtro.filtroTodos = !this.filtroNoCancelados;
    this.filtro.incluirPlanesCancelados = this.incluirPlanesCancelados;
    this.filtro.fechaDesdeCancelados = moment.utc(this.fechaDesdeCancelados).format('YYYY-MM-DD');
    this.filtro.fechaHastaCancelados = moment.utc(this.fechaHastaCancelados).format('YYYY-MM-DD');
    this.filtro.fechaDesdeTodos = moment.utc(this.fechaDesdeTodos).format('YYYY-MM-DD');
    this.filtro.fechaHastaTodos = moment.utc(this.fechaHastaTodos).format('YYYY-MM-DD');
  },
  computed: {
  },     
  methods: {
    filtrar() {
      this.$emit('filtrar', this.filtro);
    },
    limpiarFiltro() {
      this.filtro.filtroNoCancelados = true;
      this.filtro.incluirPlanesCancelados = false;
    },
  },
  watch: {
    'filtro.filtroNoCancelados' : function(newVal, oldVal) {
      this.filtro.filtroTodos = !(/true/i).test(this.filtro.filtroNoCancelados);
      this.showOpcionesNoCancelados = (/true/i).test(this.filtro.filtroNoCancelados);
      this.showOpcionesTodos = !(/true/i).test(this.filtro.filtroNoCancelados);
    },
  }    
}
</script>

<style>
  .planes-pagos-list .filtro small.text-muted {
    position: relative;
    top: -15px;
    left: 15px;
  }
</style>
